<template>
  <div id="dashboard">
    <div class="content-wrapper" style="max-width: 1140px;" id="scrolling-content">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto" style="justify-content: center;" v-dragscroll.x>
          <li class="nav-item">
            <el-button size="small" round :icon="overview.loading == true ? 'el-icon-loading' : ''" :type="overview.isActive ? 'primary' : ''" @click="jump('#overview')">{{ $t("pages.event.eventDashboard.overview") }}</el-button>
          </li>
          <li class="nav-item" v-if="registerFormList.length > 0">
            <el-button size="small" round :icon="registration.loading != false ? 'el-icon-loading' : ''" :type="registration.isActive ? 'primary' : ''" @click="jump('#registration')">{{ $t("pages.event.eventDashboard.registrationSale") }}</el-button>
          </li>
          <!-- <li class="nav-item">
            <el-button size="small" round :icon="abstract.loading == true ? 'el-icon-loading' : ''" :type="abstract.isActive ? 'primary' : ''" @click="jump('#abstract')">{{ $t("pages.event.eventDashboard.notices") }}</el-button>
          </li> -->
          <li class="nav-item">
            <el-button size="small" round :icon="live.loading == true ? 'el-icon-loading' : ''" :type="live.isActive ? 'primary' : ''" @click="jump('#live')">{{ $t("pages.event.eventDashboard.liveEvent") }}</el-button>
          </li>
          <li class="nav-item">
            <el-button size="small" round :icon="content.loading == true ? 'el-icon-loading' : ''" :type="content.isActive ? 'primary' : ''" @click="jump('#content')">{{ $t("pages.event.eventDashboard.contentAnalysis") }}</el-button>
          </li>
          <li class="nav-item">
            <el-button size="small" round :icon="certificate.loading == true ? 'el-icon-loading' : ''" :type="certificate.isActive ? 'primary' : ''" @click="jump('#certificate')">{{ $t("pages.event.eventDashboard.certificate") }}</el-button>
          </li>
          <li class="nav-item">
            <el-button size="small" round :icon="automatedmessages.loading == true ? 'el-icon-loading' : ''" :type="automatedmessages.isActive ? 'primary' : ''" @click="jump('#notification')">{{ $t("pages.event.eventDashboard.messageAnalysis") }}</el-button>
          </li>
          <li class="nav-item">
            <el-button size="small" round :icon="onsite.loading == true ? 'el-icon-loading' : ''" :type="onsite.isActive ? 'primary' : ''" @click="jump('#onsite')">{{ $t("pages.event.eventDashboard.onsiteAnalysis") }}</el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn" id="overview">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.overview") }}</h5>
              <span v-if="overview != null && overview.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(calculatedDate(overview.data.lastCalculated)).fromNow()])"></span>
              <!-- <span v-if="overview != null && overview.data != null" > {{ calculatedDate(overview.data.lastCalculated) }}</span> -->
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="overview.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getOverview', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="overview.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('overview')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="overview.isActive">
              <div class="card-body">
                <Overview />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div>

      <template v-if="registerFormList.length > 0">
        <!-- :id="index == 0 ? 'registration' : 'registration-' + index" v-for="(item, index) in registerFormList" :key="index" -->
        <div class="content animated fadeIn" id="registration">
          <div class="card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">Kayıt & Satış</h5>
                <!-- <span v-if="registrationFormData.find(x => x.registrationFormId == item.id) != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(registrationFormData.find(x => x.registrationFormId == item.id).lastCalculated).fromNow()])"></span> -->
              </div>
              <div class="header-elements flex-shrink-0 registration-header-btns" :class="{ active: registration.isActive }">
                <portal-target name="tab-refresh"></portal-target>
                <el-button-group>
                  <el-tooltip class="item" effect="dark" :content="$t('pages.event.eventDashboard.excelDownload')" placement="top">
                    <el-button icon="fas fa-download" size="mini" @click="downloadRegistrationExcell(null)" round></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                    <el-button :icon="registration.isActive == true ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('registration', true)" round></el-button>
                  </el-tooltip>
                </el-button-group>
              </div>
            </div>
            <transition name="slide-fade">
              <div v-if="registration.isActive">
                <div class="card-body">
                  <el-tabs type="card" v-model="tabIndex">
                    <el-tab-pane :label="item.title" :id="index == 0 ? 'registration' : 'registration-' + index" v-for="(item, index) in registerFormList" :key="index + 'tab-title-' + item.id" :name="index.toString()">
                      <div class="registration-tab-content pt-2">
                        <Registration :registrationFormId="item.id" v-if="parseInt(tabIndex) == index" :key="item.id + '-' + tabRenderer" />
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
                <div class="card-footer"></div>
              </div>
            </transition>
          </div>
        </div>
      </template>
      <!-- 
      <div class="content animated fadeIn" id="abstract">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.notices") }}</h5>
              <span v-if="abstract.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(abstract.data.lastCalculated).fromNow()])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="abstract.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getAbstract', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="abstract.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('abstract')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="abstract.isActive">
              <div class="card-body">
                <Abstract />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div> -->

      <div class="content animated fadeIn" id="live">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.liveEventExperience") }}</h5>
              <span v-if="live.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(live.data.lastCalculated).fromNow()])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="live.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getLive', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="live.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('live')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="live.isActive">
              <div class="card-body">
                <Live />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div>

      <div class="content animated fadeIn" id="content">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.contentAnalysis") }}</h5>
              <span v-if="content.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(content.data.lastCalculated).fromNow()])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="content.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getContent', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="content.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('content')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="content.isActive">
              <div class="card-body">
                <Content />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div>

      <div class="content animated fadeIn" id="certificate">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.digitalCertificate") }}</h5>
              <span v-if="certificate.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(certificate.data.lastCalculated).fromNow()])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="certificate.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getCertificate', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="certificate.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('certificate')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="certificate.isActive">
              <div class="card-body">
                <Certificate />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div>

      <div class="content animated fadeIn" id="notification">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.messageAnalysis") }}</h5>
              <span v-if="automatedmessages.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(automatedmessages.data.lastCalculated).fromNow()])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="automatedmessages.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getAutomatedMessages', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('pages.event.eventDashboard.excelDownload')" placement="top">
                  <el-button icon="fas fa-download" size="mini" @click="downloadNotificationExcell" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="automatedmessages.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('automatedmessages')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="automatedmessages.isActive">
              <div class="card-body">
                <Notification />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div>

      <div class="content animated fadeIn" id="onsite">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("pages.event.eventDashboard.onsiteAnalysis") }}</h5>
              <span v-if="onsite.data != null" v-html="$t('pages.event.eventDashboard.updateTime', [$moment(onsite.data.lastCalculated).fromNow()])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="onsite.loading == true ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="$store.dispatch('getOnsite', { forceRefresh: true })" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="onsite.isActive ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="toggleIsActive('onsite')" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="onsite.isActive">
              <div class="card-body">
                <Onsite />
              </div>
              <div class="card-footer"></div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Overview from "../../components/dashboard/Overview.vue";
import Registration from "../../components/dashboard/Registration.vue";
import Abstract from "../../components/dashboard/Abstract.vue";
import Live from "../../components/dashboard/Live.vue";
import Content from "../../components/dashboard/Content.vue";
import Certificate from "../../components/dashboard/Certificate.vue";
import Notification from "../../components/dashboard/Notification.vue";
import Onsite from "../../components/dashboard/Onsite.vue";

import { dragscroll } from "vue-dragscroll";
import debounce from "lodash/debounce";

export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.dashboard")
    };
  },
  name: "dashboard",
  directives: {
    dragscroll
  },
  components: {
    Overview,
    Registration,
    Abstract,
    Live,
    Content,
    Certificate,
    Notification,
    Onsite
  },
  data() {
    return {
      loading: false,
      statistic: null,
      scrollPosition: null,
      tabIndex: null,
      tabRenderer: +new Date()
    };
  },
  methods: {
    refreshTabs() {
      this.registration.loading = true;
      this.$store.dispatch("getRegisterForm");
      var index = parseInt(this.tabIndex);
      var dummy = this.registerFormList[index];
      this.registerFormList.splice(index, 1, dummy);
      this.registration.loading = false;
    },
    downloadRegistrationExcell(id) {
      this.exportXlsx(14, id, null);
    },
    downloadNotificationExcell() {
      this.exportXlsx(22, null, null);
    },
    calculatedDate(date) {
      var a = this.$moment(date);
      a.add(-10, "seconds");
      return a;
    },
    async toggleIsActive(data, id) {
      if (data == "overview") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.overview.isActive });

      if (data == "content") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.content.isActive });

      if (data == "certificate") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.certificate.isActive });

      if (data == "automatedmessages") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.automatedmessages.isActive });

      if (data == "abstract") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.abstract.isActive });

      if (data == "onsite") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.onsite.isActive });

      if (data == "live") await this.$store.dispatch("setIsActive", { data: data, isActive: !this.live.isActive });

      if (data == "registration") await this.$store.dispatch("setIsActive", { data: data, isActive: this.registration.isActive != id ? id : false });
    },

    handleScroll(pos) {
      this.scrollPosition = pos;
    },
    async jump(h) {
      if (h == "#overview" && !this.overview.isActive) {
        await this.toggleIsActive("overview");
      } else if (h == "#registration" && !this.registration.isActive) {
        if (this.registerFormList.length > 0) {
          await this.toggleIsActive("registration", this.registerFormList[0].id);
        }
      } else if (h == "#abstract" && !this.abstract.isActive) {
        await this.toggleIsActive("abstract");
      } else if (h == "#live" && !this.live.isActive) {
        await this.toggleIsActive("live");
      } else if (h == "#content" && !this.content.isActive) {
        await this.toggleIsActive("content");
      } else if (h == "#certificate" && !this.certificate.isActive) {
        await this.toggleIsActive("certificate");
      } else if (h == "#notification" && !this.automatedmessages.isActive) {
        await this.toggleIsActive("automatedmessages");
      } else if (h == "#onsite" && !this.onsite.isActive) {
        await this.toggleIsActive("onsite");
      }
      var top = document.querySelector(h).offsetTop;
      window.scrollTo({ top: top - 100, behavior: "smooth" });
    }
  },
  mounted() {
    this.$store.dispatch("getRegisterForm");
    this.handleDebouncedScroll = debounce(this.handleScroll, 100);
    window.addEventListener("scroll", event => {
      this.handleDebouncedScroll(window.scrollTop);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
  created() {},
  computed: {
    overview() {
      return this.$store.getters.getDashboardOverview;
    },
    content() {
      return this.$store.getters.getDashboardContent;
    },
    certificate() {
      return this.$store.getters.getDashboardCertificate;
    },
    automatedmessages() {
      return this.$store.getters.getDashboardAutomatedMessages;
    },
    abstract() {
      return this.$store.getters.getDashboardAbstract;
    },
    onsite() {
      return this.$store.getters.getDashboardOnsite;
    },
    live() {
      return this.$store.getters.getDashboardLive;
    },
    registration() {
      return this.$store.getters.getDashboardRegistration;
    },
    registrationFormData() {
      return this.$store.getters.getDashboardRegistrationForms;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    }
  }
};
</script>

<style lang="less">
#dashboard {
  #dashboard-content {
    .data-card {
      min-height: 164px;
    }
  }

  .el-row {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

  .el-table__row {
    &:last-child {
      .el-table__cell {
        border-bottom: unset !important;
      }
    }
  }

  .el-table::before {
    display: none;
  }

  .data-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    min-height: 146px;
    padding: 16px;
    height: 100%;
    position: relative;

    .card-info {
      text-align: left;
      color: #292f3b;
      height: 100%;

      .title {
        span {
          font-size: 14px;
          font-weight: 500;
        }
      }

      .value {
        span {
          font-size: 20px;
          font-weight: 600;
        }
      }

      .description {
        padding-right: 56px;
        span {
          font-size: 13px;
        }
      }
    }

    .card-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 4px solid #fbfbfb;
      border-radius: 50%;
      min-width: 48px;
      height: 48px;
      position: absolute;
      right: 16px;

      i {
        font-size: 18px;
        display: flex;
        justify-content: center;
      }
    }
  }

  .overview-table-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0px;

    h3 {
      color: #292f3b;
      font-weight: 600;
      font-size: 18px;
      margin: 0px;
      padding: 0px;
      line-height: 30px;
    }

    .input-container {
      margin-left: auto;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;

      .el-button-group {
        width: 100%;
      }

      .el-select {
        max-width: 250px;
      }
    }

    button {
      height: 38px;
      border: unset;
      i {
        font-size: 18px;
        color: #292f3b;
      }
    }
  }

  .pie-chart-container {
    width: 100%;
    min-height: 240px;
    position: relative;

    #overview-chart {
      min-height: 240px;
    }

    #emailvoucher-chart {
      min-height: 240px;
    }

    #smsvoucher-chart {
      min-height: 240px;
    }

    #automatedmessages-chart {
      min-height: 240px;
    }

    #abstract-chart {
      min-height: 240px;
    }

    #infoemails-chart {
      min-height: 240px;
    }

    #paymentstatistics-chart {
      min-height: 240px;
    }

    #packetstatistics-chart {
      min-height: 240px;
    }
  }

  .statistics-container {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 16px;
    position: relative;

    .overview-table-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0px 0px 16px 0px;

      h3 {
        color: #292f3b;
        font-weight: 600;
        font-size: 16px;
        margin: 0px;
        padding: 0px;
      }

      button {
        height: 38px;
        border: unset;
        i {
          font-size: 18px;
          color: #292f3b;
        }
      }
    }

    .program-shorting {
      background-color: #ffdf00;
      border-radius: 6px;
      text-align: center;

      span {
        color: #292f3b;
        font-weight: 600;
      }
    }

    .program-avg-rate {
      i {
        margin-right: 6px;
        color: #ffdf00;
      }
    }

    .show-all {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 16px;
    }
  }
}

.upgrade-overlay {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.34);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
  backdrop-filter: blur(5px);
  border-radius: 8px;
  overflow: hidden;

  h3 {
    color: #292f3b;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px !important;
    line-height: normal;
  }

  p {
    color: #505763;
    font-size: 13px;
    font-weight: 400;
  }

  button {
    margin-top: 6px;
  }
}
.registration-header-btns {
  display: flex;
  &.active {
    .vue-portal-target {
      .el-button {
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
      }
    }
    .el-button-group {
      & > :first-child {
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/EventDashboard.vue